import * as React from 'react';
import { styled } from '@mui/system';
import { Card, Button } from '@mui/material';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Typography from '@mui/material/Typography';

import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import BookIcon from '@mui/icons-material/Book';
import { toMonthShortName } from '../../../../utils/date';
import Link from '@mui/material/Link';
import {
  useLikeNoteMutation,
  useUnlikeNoteMutation,
  useSaveNoteMutation,
  useUnsaveNoteMutation,
} from '../../../../store/api/noteApi';
import DOMPurify from 'dompurify';

import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';
import { DEFAULT_AVATAR } from '../../../../utils/constant';

const NoteCardContainer = styled('div')(({ theme }) => ({
  width: '461px',
  background:
    'linear-gradient(195.04deg, rgba(255, 255, 255, 0.32) -0.54%, rgba(255, 255, 255, 0.08) 100%)',
  border: '1px solid #FFFFFF',
  borderRadius: '4px',
  margin: 'auto',
  padding: '15px 12px 25px',
  [theme.breakpoints.down('1000')]: {
    width: 'auto',
    padding: '0px 0px 0px',
    margin: '0px',
    border: '0px',
  },

  [theme.breakpoints.down('750')]: {
    width: 'auto',
    padding: '0px 0px 0px',
    margin: '0px',
    border: '0px',
  },
}));

const NoteAuthor = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '20px',
  color: 'black',
  lineHeight: '25px',
  margin: '0 9px 16px',
  fontFamily: 'Fjalla One',

  [theme.breakpoints.down('600')]: {
    fontweight: '400',
    fontsize: '16px',
    lineHeight: '21px',
  },
  [theme.breakpoints.down('900')]: {
    marginBottom: '10px',
  },
}));

const UserImg = styled('div')(({ theme }) => ({
  width: '50px',
  height: '50px',
  marginRight: '14px',
  '& img': {
    borderRadius: '75px',
    objectFit: 'cover',
  },
  [theme.breakpoints.down('600')]: {
    '& img': {
      margin: '10px 9px 16px',
      width: '40px',
      height: '40px',
    },
  },
}));

const Line = styled('div')(({ theme }) => ({
  height: '2px',
  background: '#AA9178',
  margin: '0 9px',
  [theme.breakpoints.down('600')]: {
    height: '0px',
    margin: '0px 0px',
  },
}));

const NoteCardTitle = styled('div')({
  fontFamily: 'Fjalla one',
  fontSize: '18px',
  lineHeight: '23px',
  margin: '9px',
  color: '#AB9178',
});

const NoteTime = styled('div')({
  fontFamily: 'Raleway',
  color: '#AB9178',
  margin: '0 9px',
  fontSize: '16px',
  lineHeight: '19px',
});

const NoteDescription = styled('div')({
  fontFamily: 'Raleway',
  color: '#000',
  lineHeight: '19px',
  fontSize: '16px',
  margin: '6px 9px 4px',
});

const NoteImg = styled('div')({
  marginTop: '6px',
  '& img': {
    width: '100%',
    height: '100%',
  },
});

const NoteCardFunction = styled('div')({
  display: 'flex',
  alignItems: 'center',
  margin: '4px 14px',
  justifyContent: 'space-between',
  fontFamily: 'Raleway',
  color: '#AB9178',
});

const FunctionLeft = styled('div')({
  display: 'flex',
  fontSize: '18px',
  color: '#AB9178',
  alignItems: 'center',
});

const LikeNum = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginRight: '15px',
  marginLeft: '5px',
  marginBottom: '5px',
  fontSize: '18px',
});

const LikePeople = styled('div')({
  fontFamily: 'Raleway',
  fontSize: '14px',
  margin: '2px 14px 8px',
  color: 'black',
  '& span': {
    fontWeight: 'bold',
  },
});

const SocialBtn = styled(Button)({
  padding: '0',
  border: 'none',
  color: '#AB9178',
  minWidth: 'auto',
});

const LikePeopleBtn = styled('button')({
  padding: '0',
  border: 'none',
  fontWeight: 'bold',
  cursor: 'pointer',
  fontFamily: 'Raleway',
  backgroundColor: 'transparent',
});
const Line2 = styled('div')({
  height: '2px',
  background: '#AA9178',
  margin: '0 9px',
});

const NoteCard = ({ props }) => {
  const currentUserId = useSelector(selectUser);

  const imgURL = () => {
    const defaultImg = props.author.avatar;
    if (
      props.attachments == undefined ||
      props.attachments == null ||
      props.attachments.length <= 0
    ) {
      //return default img: authors avatar
      return defaultImg;
    } else {
      return props.attachments[0].url;
    }
  };
  const likedUser = () => {
    const defaultLikedUser = 'None';
    if (props.likedUsers == undefined || props.likedUsers == null || props.likedUsers.length <= 0) {
      //return default text: None
      return defaultLikedUser;
    } else {
      return props.likedUsers[0].userName;
    }
  };
  const noteId = props._id;
  const { likedUsers, savedUsers } = props;
  const [likeNote] = useLikeNoteMutation();
  const [unlikeNote] = useUnlikeNoteMutation();
  const [saveNote] = useSaveNoteMutation();
  const [unsaveNote] = useUnsaveNoteMutation();

  const likeOrUnlike = async () => {
    if (likedUsers.find((ele) => ele._id === currentUserId)) {
      await unlikeNote({ noteId, userId: currentUserId });
    } else {
      await likeNote({ noteId, userId: currentUserId });
    }
  };

  const saveOrUnSave = async () => {
    if (savedUsers.includes(currentUserId)) {
      await unsaveNote({ noteId, userId: currentUserId });
    } else {
      await saveNote({ noteId, userId: currentUserId });
    }
  };
  // const date = new Date(props.date).toLocaleString();

  let year = '';
  let month = '';
  let day = '';
  let date = '';

  if (props.date !== undefined) {
    year = props.date.split('-')[0];
    month = toMonthShortName(parseInt(props.date.split('-')[1]));
    day = props.date.split('-')[2].split('T')[0];
    date = day + ' ' + month + ', ' + year;
  } else {
    date = 'Invalid Date';
  }
  // const getWordStr = (str) => {
  //   return str.split(/\s+/).slice(0, 22).join(' ');
  // };
  const linkUrl = `/note/${props._id}`;
  let cleanNoteContent = DOMPurify.sanitize(props.content, { USE_PROFILES: { html: true } });
  return (
    <NoteCardContainer elevation={3}>
      <NoteAuthor>
        <UserImg>
          <img src={props.author.avatar || DEFAULT_AVATAR} alt="" width="100%" />
        </UserImg>
        <p>{props.author.userName}</p>
      </NoteAuthor>
      <Line />
      <NoteCardTitle>{props.title}</NoteCardTitle>
      <NoteTime>{date}</NoteTime>
      <NoteDescription>
        <Typography dangerouslySetInnerHTML={{ __html: cleanNoteContent }}></Typography>
        <Link href={linkUrl} underline="none" color={'#AB9178'}>
          (Go to Details)
        </Link>
      </NoteDescription>
      <NoteImg>
        <img src={imgURL()} alt="" />
      </NoteImg>
      <NoteCardFunction>
        <FunctionLeft>
          <SocialBtn onClick={likeOrUnlike}>
            {likedUsers.find((ele) => ele._id === currentUserId) ? (
              <ThumbUpAltIcon />
            ) : (
              <ThumbUpOffAltIcon />
            )}
          </SocialBtn>
          <LikeNum>{props.likedUsers.length}</LikeNum>
          <SocialBtn>
            <ShareOutlinedIcon />
          </SocialBtn>
        </FunctionLeft>
        <SocialBtn onClick={saveOrUnSave}>
          {savedUsers.includes(currentUserId) ? <BookIcon /> : <ClassOutlinedIcon />}
        </SocialBtn>
      </NoteCardFunction>
      <LikePeople>
        Liked by <LikePeopleBtn>{likedUser()}</LikePeopleBtn> and <span>others</span>
      </LikePeople>
      <Line2 />
    </NoteCardContainer>
  );
};

export default NoteCard;
